<template>
  <div class="details">
    <QS-scroller-box>
      <!-- 详情页 -->
      <div class="details_content">
        <!-- <div class="details_content_title"> -->
          <QS-h3-title class="purchase" title="企业租赁订单详情">
            <el-button v-if="tabType" slot="right" @click="goBack">返回</el-button>
          </QS-h3-title>
        <!-- </div> -->
        <div class="splitline mt16 mb16" />
        <!-- --开始------订单信息------------- -->
        <div class="details_content_repeat">
          <div>
            <QS-h4-title title="订单信息" >
            </QS-h4-title>
          </div>
          <div class="details_content_repeat_hundred">
            <el-form label-width="102px" >
              <column-box :source="baseInfo" :list="baseInfoList">
                <el-form-item
                  :label="'合同附件' + columnSeparator"
                  prop="contractAttachment"
                  class="enclosure alone"
                >
                  <div v-if="isEdit">
                    <UploadCommon
                      :fileList="baseInfo.contractAttachment"
                      :limit="20"
                      :drag="true"
                      listType="text"
                      :sizeType="4"
                    ></UploadCommon>
                  </div>
                  <div v-else>
                    <div v-if="this.baseInfo.contractAttachment && JSON.parse(this.baseInfo.contractAttachment)">
                      <div
                        v-for="(item, index) in this.getEchoUploadFileData(this.baseInfo.contractAttachment,true)"
                        :key="'baseInfo' + index"
                        class="uptext"
                      >
                        <p
                          v-down="{ url: item.url, name: item.name }"
                          class="blue"
                        >
                          <i class="el-icon-document blue"></i>
                          {{ item.name }}
                        </p>
                      </div>
                    </div>
                    <div v-else>--</div>
                  </div>
                </el-form-item>
              </column-box>
            </el-form>
          </div>
        </div>
        <!-- --结束------采购订单基本信息------------- -->

        <!-- --开始------车辆信息------------- -->
        <car-info :payInfo="baseInfo"></car-info>
        <!-- --结束------车辆信息------------- -->

        <!-- 付款单信息 -->
        <detail-payment-info :payInfo="baseInfo"></detail-payment-info>

        <!-- 收款单信息 -->
        <detail-receivable-info :payInfo="baseInfo"></detail-receivable-info>

      </div>
      <template slot="bottomAction" v-if="isEdit">
        <el-button
          size="small"
          type="primary"
          @click="doSave"
          :loading="btnLoading"
          >保存修改</el-button
        >
        <el-button size="small" @click="cancelEdit">取消</el-button>
      </template>
    </QS-scroller-box>
  </div>
</template>

<script>
import carInfo from '../components/detailCarInfo.vue'
import detailPaymentInfo from '../components/detailPaymentInfo.vue'
import detailReceivableInfo from '../components/detailReceivableInfo.vue'
// eslint-disable-next-line import/no-cycle
import {
  getLeaseDetail,
  doLeaseOrderEdit,
} from '@/api/domain/orders'
import selectOption from '@/store/dict/selectOptionDict'
import { mapState } from 'vuex'

export default {
  components: {
    carInfo,
    detailPaymentInfo,
    detailReceivableInfo,
  },
  data() {
    return {
      orderState: {
        1: '已创建',
        2: '进行中',
        3: '已关闭',
      },
      tabType: '', // 客户&车辆详情/个人租赁跳转到个人租赁详情的类型
      btnLoading: false,
      isEdit: false,
      // 订单信息
      baseInfoList: [
        {
          key: 'id',
          name: '订单ID',
        },
        {
          key: 'typeName',
          name: '订单类型',
        },
        {
          key: 'state',
          name: '订单状态',
        },
        {
          key: 'customerName',
          name: '客户',
        },
        {
          key: 'customerId',
          name: '客户ID',
        },
        {
          key: 'gmtCreate',
          name: '订单创建时间',
        },
        {
          key: 'contractStartDate',
          name: '合同开始日期',
        },
        {
          key: 'contractEndDate',
          name: '合同结束日期',
        },
        {
          key: 'deposit',
          name: '总押金',
        },
        {
          key: 'manageFee',
          name: '一次性管理费',
        },
        {
          key: 'serviceFee',
          name: '其他服务费',
        },
        {
          key: 'contractNo',
          name: '业务合同编号',
        },
        {
          key: 'remarks',
          name: '备注',
        },
        {
          key: 'deptName',
          name: '所属部门',
        },
      ],
      // 采购订单基本信息右侧内容
      baseInfo: {
        state: null,
        attachment: [],
      },
      // 保存当前ID
      detailsId: null,
    }
  },
  computed: {
    ...mapState({
      // eslint-disable-next-line vue/no-unused-properties
      freeTypeList: (state) => state.global.freeTypeList, // 收款项
    }),
  },
  created() {
    this.tabType = this.$route.query.tabType || ''
    this.$store.dispatch('getPaymentMethods', { type: 'financeFeeType' }) // 获取收款项
  },
  mounted() {
    const { id } = this.$route.query
    if (!id) {
      this.$message.error('请携带必要参数')
      this.$router.go(-1)
    }
    this.detailsId = String(id)
    this.getPageData()
  },
  methods: {
    // 返回上一级
    goBack() {
      this.$router.go(-1)
    },

    // 合同保存按钮
    async doSave() {
      this.btnLoading = true
      const { code, data } = await doLeaseOrderEdit({
        orderId: Number(this.detailsId),
        orderNo: this.baseInfo.orderNo, // 合同编号
        attachment: this.getUoloadCommonFileData(this.baseInfo.attachment),
      })
      if (code === 1) {
        if (data) {
          this.btnLoading = false
          this.$message({
            message: '保存成功',
            type: 'success',
          })
          // 刷新页面数据
          this.getPageData()
          this.isEdit = false
        }
      } else {
        this.btnLoading = false
        this.$message.error('保存失败请再次尝试')
      }
    },
    cancelEdit() {
      this.isEdit = false
    },

    handle() {
      // 订单类型
      const type = selectOption.typeofcontractDict[this.baseInfo.type]
      const purchaseType =
        selectOption.purchaseTypeDict[this.baseInfo.purchaseType]
      const state = this.orderState[this.baseInfo.state] // 订单状态
      const attachment = this.getEchoUploadFileData(this.baseInfo.attachment)
      this.baseInfo = {
        ...this.baseInfo,
        type,
        purchaseType,
        state,
        attachment,
      }
    },

    // 详情页请求数据
    async getDetails() {
      try {
        const { code, data } = await getLeaseDetail({
          id: Number(this.detailsId),
        })
        if (code === 1) {
          this.baseInfo = data.orderInfo // 订单基本信息
          this.baseInfo.typeName = '企业订单'
          this.handle()
        }
      } catch (error) {
        console.log(error)
      }
    },

    getPageData() {
      this.getDetails() // 订单详情
    },
  },
}
</script>
<style lang="scss" scoped>
::v-deep .el-form-item__content {
  margin-left: 0 !important;
}
.details {
  min-height: 1422px;
  .details_content {
    .details_content_title {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .purchase {
        margin: 0;
      }
      h3 {
        font-family: PingFangSC-Medium;
        font-size: 20px;
        color: #323233;
        font-weight: 500;
        margin: 0;
      }
    }
    .details_content_repeat {
      margin-bottom: 16px;
      ::v-deep .qs-h4-container-left {
        font-size: 16px;
      }
      .details_content_repeat_hundred {
        // margin-left: 100px;
        ::v-deep .column-title {
          text-align: right;
          padding-right: 10px;
          color: #333333;
          min-width: 115px !important;
        }
        .enclosure {
          ::v-deep .el-form-item__label {
            width: 117px !important;
          }
        }
      }
    }
    // 文件图标颜色
    .uptext {
      .blue {
        color: #2e7eff;
        display: inline-block;
        margin: 0;
      }
    }
  }
  .i-title-box {
    position: relative;
    .i-title-btn {
      position: absolute;
      top: 4px;
      right: 0;
    }
  }
  .txt-right {
    text-align: right;
  }
}
</style>
